import { InjectionToken, Provider } from '@angular/core';

export const WindowToken = new InjectionToken<Window>('window');

export const WindowProvider: Provider = {
  provide: WindowToken,
  useFactory: windowFactory,
};

export function windowFactory() {
  return window;
}
